import Icon from '../components/Icon.vue'

Icon.register({
  'grin-stars': {
    width: 496,
    height: 512,
    paths: [
      {
        d: 'M248 8c137 0 248 111 248 248s-111 248-248 248-248-111-248-248 111-248 248-248zM94.6 168.9c-6.2 1-8.9 8.6-4.3 13.3l25.4 24.6-6 34.9c-1 6.2 5.3 11 11 7.9l31.3-16.3 31.2 16.2c5.7 3.1 12-1.7 11-7.9l-6-34.9 25.4-24.6c4.6-4.6 1.9-12.2-4.3-13.2l-34.9-5-15.5-31.6c-2.9-5.8-11-5.8-13.9 0l-15.5 31.6zM248 432c60.6 0 134.5-38.3 143.8-93.3 1.9-11.8-9.2-21.6-20.7-17.9-30.2 9.7-75.1 15.2-123.1 15.2s-92.9-5.5-123.1-15.2c-11.4-3.6-22.7 6.1-20.7 17.9 9.3 55 83.2 93.3 143.8 93.3zM405.7 182.1c4.6-4.6 1.9-12.2-4.4-13.1l-34.9-5-15.5-31.6c-2.9-5.8-11-5.8-13.9 0l-15.5 31.6-34.9 5c-6.2 1-8.8 8.6-4.3 13.2l25.4 24.6-6 34.9c-1 6.2 5.3 11 11 7.9l31.3-16.3 31.3 16.2c5.7 3.1 12-1.7 11-7.9l-6-34.9z'
      }
    ]
  }
})
